import { TranslateCellComponent } from '@shared/components/table/cells/translate-cell/translate-cell.component';
import { Columns } from '@shared/interfaces/table/column-config';

export const consumptiontypePartial: Columns<any> = {
  title: 'meteringPoint.timeSeries.consumptionType',
  key: 'consumptionType',
  cellRenderer: TranslateCellComponent,
  cellRendererParams: {
    notspecified: '',
    ok: 'enum.readingtype.ok',
    read: 'enum.readingtype.read',
    estimated: 'enum.readingtype.estimated',
    missing: 'enum.readingtype.missing',
    notapplicable: 'enum.readingtype.notapplicable',
    calculated: 'enum.readingtype.calculated'
  }
}
